export enum StatusAccess {
  Closed = 'CLOSED',
  Open = 'OPEN',
  Paused = 'ON HOLD',
  Caution = 'CAUTION',
  Default = 'DEFAULT',
}
